import {
  CREATE_CONSIGNMENT_ORDER,
  DELETE_CONSIGNMENT_ORDER,
  GET_CONSIGNMENT_ORDERS,
  GET_CONSIGNMENT_ORDER_BY_ID,
  GET_CONSIGNMENT_ORDER_MOVEMENTS,
  UPDATE_CONSIGNMENT_ORDER,
} from '../types';

const initialState = {
  consignmentOrders: [],
  consignmentOrderById: {},
  consignmentOrderDelete: null,
  consignmentOrderMovement: [],
};

export default function ConsignmentOrder(state = initialState, action) {
  switch (action.type) {
    case CREATE_CONSIGNMENT_ORDER:
      return {
        ...state,
        consignmentOrders: [...state.consignmentOrders, action.payload],
      };
    case GET_CONSIGNMENT_ORDERS:
      return {
        ...state,
        consignmentOrders: action.payload,
      };
    case GET_CONSIGNMENT_ORDER_BY_ID:
      return {
        ...state,
        consignmentOrderById: action.payload,
      };
    case UPDATE_CONSIGNMENT_ORDER:
      return {
        ...state,
        consignmentOrders: state.consignmentOrders.map((order) =>
          order.id === action.payload.id ? (order = action.payload) : order
        ),
      };
    case DELETE_CONSIGNMENT_ORDER:
      return {
        ...state,
        consignmentOrders: state.consignmentOrders.map((order) =>
          order.id === action.payload.id ? (order = action.payload) : order
        ),
      };
    case GET_CONSIGNMENT_ORDER_MOVEMENTS:
      return {
        ...state,
        consignmentOrderMovement: action.payload,
      };

    default:
      return state;
  }
}
